import axios from "axios";
import { Environment } from "../utils/environments";
import { RequestParams } from "../types/apiClientTypes";
import { auth } from "../firebase";

const getIdToken = async () => {
  const currentUser = auth.currentUser;
  if (currentUser) {
    const token = currentUser.getIdToken();
    return token;
  } else {
    throw new Error("User is not logged in");
  }
};
export async function httpGet(params: any) {
  try {
    const token = await getIdToken();
    const apiEndpoint = Environment.getApiEndpoint();
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const queryParams = params.queryParams || null;
    const createParams = {
      params: queryParams,
      headers: headers,
    };
    if (Environment.getBuildType() != "prod") {
      console.log(createParams);
    }
    const response = await axios.get(
      `${apiEndpoint}${params.pathName}`,
      createParams
    );
    return response;
  } catch (error) {
    if (Environment.getBuildType() != "prod") {
      console.error("HTTP GET Error:", error);
    }
    throw error;
  }
}

export async function httpPost(params: RequestParams, useId = true) {
  const apiEndpoint = Environment.getApiEndpoint();
  var token;
  if (useId) {
    token = await getIdToken();
  }

  var headers = {};
  headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
  if (!useId) {
    headers["Authorization"] = Environment.getDefaultAuthId();
  }
  if (Environment.getBuildType() != "prod") {
    console.log(params, headers);
  }
  return await axios.post(
    `${apiEndpoint}${params.pathName}`,
    params.bodyParams ? JSON.stringify(params.bodyParams) : null,
    {
      headers: headers,
    }
  );
}
